/**
 * A local image to use for courses and such.
 * @type { string }
 */
const HOYA_COURSE_PLACEHOLDER_IMAGE = '/images/eye-white-large.png';
const HOYA_COURSE_PLACEHOLDER_IMAGE_DARK = '/images/eye-black-small.png';
const HOYA_CATEGORY_PLACEHOLDER_IMAGE = '/images/hoya-category.png';





const SEIKO_COURSE_PLACEHOLDER_IMAGE = '/images/seiko-placeholder-@2x.jpg';
const SEIKO_HERO_ONE_IMAGE = '/images/seiko-hero-one.png';

/**
 * A fallback image to use for the banner image on the Course Details page if a
 * proper image is not available.
 * @type { string }
 */
export const DEFAULT_COURSE_BANNER_PLACEHOLDER_IMAGE = HOYA_COURSE_PLACEHOLDER_IMAGE;
export const SEIKO_DEFAULT_COURSE_BANNER_PLACEHOLDER_IMAGE = SEIKO_COURSE_PLACEHOLDER_IMAGE;
export const getDefaultCourseBanner = ( brand ) => brand == 'hoya' ? DEFAULT_COURSE_BANNER_PLACEHOLDER_IMAGE : SEIKO_DEFAULT_COURSE_BANNER_PLACEHOLDER_IMAGE;

/**
 * A fallback image to use for the thumbnail image for a course if a proper image
 * is not available.
 * @type { string }
 */
export const DEFAULT_COURSE_THUMBNAIL_PLACEHOLDER_IMAGE = HOYA_COURSE_PLACEHOLDER_IMAGE_DARK;
export const SEIKO_DEFAULT_COURSE_THUMBNAIL_PLACEHOLDER_IMAGE = SEIKO_COURSE_PLACEHOLDER_IMAGE;
export const getDefaultCourseThumbnail = ( brand ) => brand == 'hoya' ? DEFAULT_COURSE_THUMBNAIL_PLACEHOLDER_IMAGE : SEIKO_DEFAULT_COURSE_THUMBNAIL_PLACEHOLDER_IMAGE;

/**
 * A fallback image to use for the banner image on the Curriculum Details page if
 * a proper image is not available.
 * @type { string }
 */
export const DEFAULT_CURRICULUM_BANNER_PLACEHOLDER_IMAGE = HOYA_COURSE_PLACEHOLDER_IMAGE;
export const SEIKO_DEFAULT_CURRICULUM_BANNER_PLACEHOLDER_IMAGE = SEIKO_COURSE_PLACEHOLDER_IMAGE;
export const getDefaultCurriculumBanner = ( brand ) => brand == 'hoya' ? DEFAULT_CURRICULUM_BANNER_PLACEHOLDER_IMAGE : SEIKO_DEFAULT_CURRICULUM_BANNER_PLACEHOLDER_IMAGE;

/**
 * A fallback image to use for the thumbnail image for a curriculum if a proper
 * image is not available.
 * @type { string }
 */
export const DEFAULT_CURRICULUM_THUMBNAIL_PLACEHOLDER_IMAGE = HOYA_COURSE_PLACEHOLDER_IMAGE_DARK;
export const SEIKO_DEFAULT_CURRICULUM_THUMBNAIL_PLACEHOLDER_IMAGE = SEIKO_COURSE_PLACEHOLDER_IMAGE;
export const getDefaultCurriculumThumbnail = ( brand ) => brand == 'hoya' ? DEFAULT_CURRICULUM_THUMBNAIL_PLACEHOLDER_IMAGE : SEIKO_DEFAULT_CURRICULUM_THUMBNAIL_PLACEHOLDER_IMAGE;

/**
 * A fallback image to use for the banner image for a category if a proper image
 * is not available.
 * @type { string }
 */
export const DEFAULT_CATEGORY_BANNER_PLACEHOLDER_IMAGE = HOYA_CATEGORY_PLACEHOLDER_IMAGE;
export const SEIKO_DEFAULT_CATEGORY_BANNER_PLACEHOLDER_IMAGE = SEIKO_HERO_ONE_IMAGE;
export const getDefaultCategoryBanner = ( brand ) => brand == 'hoya' ? DEFAULT_CATEGORY_BANNER_PLACEHOLDER_IMAGE : SEIKO_DEFAULT_CATEGORY_BANNER_PLACEHOLDER_IMAGE;
